var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tweet"},[(_vm.getId())?_c('Tweet',{attrs:{"id":_vm.getId()}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }